// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___w6KRd","container":"styles__container___Vo35V"};